import { dateToMMDDYY2 } from "../common/date_utils";
import { ResidentStatus } from "../constants/general";
import { deleteRequest, get, post } from "./Common";

const URL = `${process.env.REACT_APP_API_URL}/api/admin`;
const URL_v1 = `${process.env.REACT_APP_API_URL}/v1/admin`;

export const prepareRequestBody = (body, jsonRequest) => {
  if (jsonRequest) {
    return JSON.stringify(body);
  }
  const formDataBody = new FormData();
  Object.keys(body).forEach((key) => {
    formDataBody.append(key, body[key]);
  });
  return formDataBody;
};

export const prepareRequestHeaders = (
  { headers = {}, method },
  jsonRequest,
  url,
  token
) => {
  if (jsonRequest) {
    headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...headers,
    };
  }

  if (token) {
    headers = {
      authorization: "Bearer " + token,
      ...headers,
    };
  }
  return headers;
};

export const getResponseBody = async (response) => {
  const textResponse = await response.text();

  return {
    // eslint-disable-next-line
    ...JSON.parse(textResponse),
  };
};

// const loginGoogle = async (token, data = {}, jsonRequest = true) => {
//   return login("google", token, data, jsonRequest);
// };

// const loginEntrata = async (token, referrer, data = {}, jsonRequest = true) => {
//   return login(referrer, token, data, jsonRequest);
// };

// const login = async (service, token, data = {}, jsonRequest = true) => {
//   const url = `${URL}/auth`;

//   // data.method = "POST";
//   // data.body =
//   // data.headers = prepareRequestHeaders(data, jsonRequest, url, null);

//   const response = await post(url, token, new Map(), prepareRequestBody({ token, service: service }, jsonRequest));

//   return getResponseBody(response);
// };

// const refreshToken = async (token, data = {}, jsonRequest = true) => {
//   const url = `${URL}/auth/refresh`;

//   data.method = "POST";
//   data.headers = prepareRequestHeaders(data, jsonRequest, url, token);

//   const response = await fetch(url, data);

//   return getResponseBody(response);
// };

const getHome = async (l1Id, authToken) => {
  const url = `${URL}/home?l1Id=${l1Id}`;

  const response = await get(url, authToken);

  if(response.ok) {
    return { response: response.parsedBody };
  } else {
    return { error: true };
  }
};


const mapCheckboxes = (checkboxes) => {
  let linkPartial= '&';
  Object.keys(checkboxes).forEach(function(key, index) {
    linkPartial+=key+'='+checkboxes[key]+'&';
  });
  return linkPartial;
};

const getRoommateMatchReport = async (
  l1Id,
  l2Id,
  l3Id,
  type,
  userRegisteredStatus,
  page,
  authToken
) => {
  let url = `${URL}/roommate/report?l1Id=${l1Id}&l2Id=${l2Id}&l3Id=${l3Id}&status=${type}&page=${page}`;

  if (userRegisteredStatus) {
    url = `${url}&registeredStatus=${userRegisteredStatus}`;
  }

  const response = await get(url, authToken);
  const success = response.status === 200;

  return { error: !success, response: response.parsedBody };
};

const getUserReport = async (
  l1Id,
  l2Id,
  l3Id,
  roomFilledLevel,
  userRegisteredStatus,
  page,
  authToken
) => {
  let url = `${URL}/users/report?l1Id=${l1Id}&l2Id=${l2Id}&l3Id=${l3Id}&reportType=${roomFilledLevel}&page=${page}`;

  if (userRegisteredStatus) {
    url = `${url}&registeredStatus=${userRegisteredStatus}`;
  }

  const response = await get(url, authToken);

  const success = response.status === 200;

  return { error: !success, response: response.parsedBody };
};

const getRoommateMatchReportCSV = async (
  l1Id,
  l2Id,
  l3Id,
  checkboxes,
  type,
  authToken,
  jsonRequest = false
) => {
  const data = {};
  const url = `${URL}/roommate/report.csv?l1Id=${l1Id}&status=${type}&l2Id=${l2Id}&l3Id=${l3Id}${mapCheckboxes(checkboxes)}`;

  data.headers = prepareRequestHeaders(
    { headers: { "Content-Type": "text/csv", Accept: "text/csv" } },
    jsonRequest,
    url,
    authToken
  );

  const response = await fetch(url, data);

  if(response.ok) {
  const blob = await response.blob();
    const filename = response.headers
    .get("content-disposition")
    .split(";")[1]
    .split("=")[1];
    return { blob, fileName: filename };
  } else {
    // eslint-disable-next-line no-console
    console.error(response.message);
  }


};


const getUserReportCSV = async (
  l1Id,
  l2Id,
  l3Id,
  checkboxes,
  roomFilledLevel,
  authToken,
  jsonRequest = false
) => {
  const data = {};
  const url = `${URL}/users/report.csv?l1Id=${l1Id}&l2Id=${l2Id}&l3Id=${l3Id}${mapCheckboxes(checkboxes)}&reportType=${roomFilledLevel}`;

  data.headers = prepareRequestHeaders(
    { headers: { "Content-Type": "text/csv", Accept: "text/csv" } },
    jsonRequest,
    url,
    authToken
  );

  const response = await fetch(url, data);

  if(response.ok) {
    const blob = await response.blob();
    const filename = response.headers
    .get("content-disposition")
    .split(";")[1]
    .split("=")[1];
    return { blob, fileName: filename };
  } else {
    // eslint-disable-next-line no-console
    console.error(response.message);
  }
};

const getUserSearchByName = async (
  l1id,
  firstName,
  lastName,
  globalSearch,
  authToken
) => {
  let url = `${URL}/users/search/name`;

  if (firstName && lastName) {
    url = `${url}?firstName=${firstName}&lastName=${lastName}`;
  } else if (firstName) {
    url = `${url}?firstName=${firstName}`;
  } else if (lastName) {
    url = `${url}?lastName=${lastName}`;
  }

  if (globalSearch) {
    url = `${url}&globalSearch=${globalSearch}`;
  }

  url = `${url}&l1Id=${l1id}&includeArchived=true`;

  const response = await get(url, authToken);

  return response.parsedBody;
};

const getUserSearchByPin = async (l1id, pin, authToken) => {
  let url = `${URL}/users/search/pin?pin=${pin}`;

  url = `${url}&l1Id=${l1id}`;

  const response = await get(url, authToken);

  return response.parsedBody;
};

const deleteUserMembership = async (membershipId, authToken) => {
  const url = `${URL}/membership?membershipId=${membershipId}`;

  const response = await deleteRequest(url, authToken);

  return response.status === 200;
};

const deleteUser = async (userId, authToken) => {
  const url = `${URL}/users?userId=${userId}`;

  const response = await deleteRequest(url, authToken);

  return response.status === 200;
};

const clearNetwork = async (l1Id, l2Id, authToken) => {
  const url = `${URL}/networks/clear/${l1Id}/${l2Id}`;

  const response = await post(url, authToken);

  return response.status === 200;
};

const requestDatesChange = async (l1Id, dates, authToken) => {
  const url = `${URL}/networks/${l1Id}/dates`;

  const l2Ids = Object.keys(dates);

  if (l2Ids.length === 0) {
    return;
  }

  const changeRequests = [];

  for (const l2Id of l2Ids) {
    const req = { l2Id, ...dates[l2Id] };

    if (req.startDate) {
      req.startDate = dateToMMDDYY2(req.startDate);
    }

    if (req.endDate) {
      req.endDate = dateToMMDDYY2(req.endDate);
    }

    changeRequests.push(req);
  }

  const response = await post(url, authToken, new Map(), {
    changes: changeRequests,
  });

  const success = response.status === 200;

  const reponse = response.parsedBody;

  if (!success) {
    return {
      success,
      error: { l2Id: reponse.error.code, message: reponse.error.description },
    };
  }
  return { success, response: reponse };
};

// const requestPasscodeChange = async (l1Id, l2Id, passCode, clear = false, authToken, data = {}, jsonRequest = true) => {
//   const url = `${URL}/networks/${l1Id}/passcode`;

//   data.method = "POST";

//   data.body = prepareRequestBody({ l2Id, clear, passCode }, jsonRequest);
//   data.headers = prepareRequestHeaders(data, jsonRequest, url, authToken);

//   const response = await fetch(url, data);
//   const status = await response.status;

//   const success = status === 200;

//   if (!success) {
//     const textResponse = await response.text();
//     const reponse = JSON.parse(textResponse);
//     return { success, error: { l2Id: reponse.error.code } };
//   }
//   return { success };
// };

const getHousingOptions = async (l1Id, l2Id, authToken) => {
  const url = `${URL}/networks/${l1Id}/subnetworks/${l2Id}/housing`;

  const response = await get(url, authToken);

  return response.parsedBody;
};

const getMajorsOptions = async (l1Id, l2Id, authToken) => {
  const url = `${URL}/networks/${l1Id}/subnetworks/${l2Id}/majors`;

  const response = await get(url, authToken);

  return response.parsedBody;
};

const requestActivationChangeHousingMajorEntry = async (
  l1Id,
  l2Id,
  activationStatus,
  type,
  authToken
) => {
  const url = `${URL}/networks/${l1Id}/subnetwork/${l2Id}/${type}`;

  const response = await post(url, authToken, new Map(), {
    activate: activationStatus,
  });

  return response.status === 200;
};

const requestNewOrEditExistingHousingMajorEntry = async (
  l1Id,
  l2Id,
  id,
  name,
  type,
  authToken
) => {
  let url = `${URL}/networks/${l1Id}/subnetwork/${l2Id}/${type}/entry`;

  if (id) {
    url = `${url}/${id}`;
  }

  const response = await post(url, authToken, new Map(), { name });

  const success = response.status === 200;
  if (success) {
    return { error: false, result: response.parsedBody };
  }
  return { error: true };
};

const requestReplaceHousingMajorEntries = async (
  l1Id,
  l2Id,
  entries,
  type,
  authToken
) => {
  const url = `${URL}/networks/${l1Id}/subnetwork/${l2Id}/${type}/entries`;

  const response = await post(url, authToken, new Map(), entries.flat());

  const success = response.status === 200;
  if (success) {
    return { error: false };
    // const textResponse = await response.text();
    // return {error: false, result: JSON.parse(textResponse)};
  }
  return { error: true };
};

const requestCopyHousingMajorEntries = async (
  l1Id,
  sourceL2Id,
  targetL2Ids,
  type,
  authToken
) => {
  const type_url = type.toLowerCase().replace(" ", "_");
  const url = `${URL}/networks/${l1Id}/subnetwork/${sourceL2Id}/${type_url}/copy`;

  const response = await post(url, authToken, new Map(), {
    targets: targetL2Ids,
  });

  const success = response.status === 200;
  if (success) {
    return { error: false };
    // const textResponse = await response.text();
    // return {error: false, result: JSON.parse(textResponse)};
  }
  return { error: true };
};

const requestCopyQuestions = async (l1Id, l2Id, l3Id, targets, authToken) => {
  const url = `${URL_v1}/network/${l1Id}/subnetwork/${l2Id}/unit/${l3Id}/questions/copy`;

  try {
    const response = await post(url, authToken, new Map(), {
      l1Id,
      l2Id,
      l3Id,
      targets,
    });

    const success = response.status === 200;

    if (success) {
      return { error: false };
    }

    const { error } = response.parsedBody;

    return { error };
  } catch (error) {
    return { error };
  }
};

const getQuestionsForNetwork = async ({ l1Id, l2Id, l3Id }, authToken) => {
  const url = `${URL_v1}/network/${l1Id}/subnetwork/${l2Id}/unit/${l3Id}/questions`;

  const response = await get(url, authToken);

  const success = response.status === 200;
  if (success) {
    return { error: false, result: response.parsedBody };
  }
  return { error: true };
};

// const updateStandardNetworkQuestions = async ({ l1Id, l2Id }, coed, authToken, data = {}, jsonRequest = true) => {
//   const url = `${URL}/networks/${l1Id}/subnetwork/${l2Id}/questions/standard`;

//   data.method = "POST";
//   data.body = prepareRequestBody({ coed }, jsonRequest);
//   data.headers = prepareRequestHeaders(data, jsonRequest, url, authToken);

//   const response = await fetch(url, data);
//   const status = await response.status;

//   const success = status === 200;
//   if (success) {
//     return { error: false };
//     // const textResponse = await response.text();
//     // return {error: false, result: JSON.parse(textResponse)};
//   }
//   return { error: true };
// };

const updateNetworkQuestionData = async (
  { l1Id, l2Id, l3Id },
  authToken,
  data = {}
) => {
  const url = `${URL_v1}/network/${l1Id}/subnetwork/${l2Id}/unit/${l3Id}/questions`;

  const type =
    data.id && !data.questionText
      ? "deleteQuestionCommands"
      : data.id
      ? "updateQuestionCommands"
      : "createCommands";

  const response = await post(url, authToken, new Map(), { [type]: [data] });

  const success = response.status === 200;
  if (success) {
    return { error: false };
  }

  return { error: true, message: response.parsedBody.error.code };
};

const updateNetworkQuestionOrder = async (
  { l1Id, l2Id, l3Id },
  authToken,
  data = {}
) => {
  const url = `${URL_v1}/network/${l1Id}/subnetwork/${l2Id}/unit/${l3Id}/questions/order`;

  const response = await post(url, authToken, new Map(), data);

  const success = response.status === 200;

  if (success) {
    return { error: false };
  }
  return { error: true, message: response.parsedBody.error.code };
};

// const deleteNetworkQuestion = async (l1Id, l2Id, questionId, authToken, data = {}, jsonRequest = true) => {
//   const url = `${URL}/networks/${l1Id}/subnetwork/${l2Id}/questions/${questionId}`;

//   data.method = "DELETE";
//   data.headers = prepareRequestHeaders(data, jsonRequest, url, authToken);

//   const response = await fetch(url, data);
//   const status = await response.status;

//   const success = status === 200;
//   if (success) {
//     return { error: false };
//   }
//   return { error: true };
// };

// const createNetworkQuestion = async (
//   l1Id,
//   l2Id,
//   aboutMe,
//   aboutMyRoomate,
//   lowSetting,
//   highSetting,
//   shortText,
//   authToken,
//   data = {},
//   jsonRequest = true
// ) => {
//   const url = `${URL}/networks/${l1Id}/subnetwork/${l2Id}/questions/`;

//   data.method = "POST";
//   data.body = prepareRequestBody(
//     {
//       questionText: aboutMe,
//       reverseText: aboutMyRoomate,
//       lowText: lowSetting,
//       highText: highSetting,
//       shortText,
//     },
//     jsonRequest
//   );
//   data.headers = prepareRequestHeaders(data, jsonRequest, url, authToken);

//   const response = await fetch(url, data);
//   const status = await response.status;

//   const success = status === 200;
//   if (success) {
//     return { error: false };
//   }
//   const errorText = JSON.parse(await response.text());
//   return { error: true, message: errorText.error.code };
// };

const loadReportSubscriptions = async (l1Id, authToken) => {
  const url = `${URL}/networks/${l1Id}/report_subscriptions`;

  const response = await get(url, authToken);

  const success = response.status === 200;

  if (success) {
    return { error: false, result: response.parsedBody };
  }
  return { error: true };
};

const getCurrrentMatchesOfMatchesGroup = async (
  l1Id,
  l2Id,
  authToken,
  data = {}
) => {
  const url = `${URL}/roommate/${l1Id}/subnetwork/${l2Id}/count`;

  const response = await get(url, authToken);

  if (response.status === 200) {
    return { error: false, result: response.parsedBody };
  }
  return { error: true };
};

const loadRooms = async (
  l1Id,
  l2Id,
  l3Id,
  page,
  idsToIgnore,
  filter,
  size,
  authToken
) => {
  let url = `${URL}/roommate/${l1Id}/subnetwork/${l2Id}/unit_type/${l3Id}/rooms_with_capacity?page=${page}&size=${size}`;

  if (idsToIgnore && idsToIgnore.length > 0) {
    url = `${url}&idsInGroup=${idsToIgnore}`;
  }

  function setFilter(fieldName, value) {
    let param = value;

    if (value === "none" || value === ResidentStatus.All) {
      return;
    }

    if (value === ResidentStatus.RenewingResident) {
      param = true;
    } else if (value === ResidentStatus.NewResident) {
      param = false;
    }

    url = `${url}&${fieldName}=${param}`;
  }

  Object.keys(filter)
    .filter((x) => filter[x])
    .forEach((x) => setFilter(x, filter[x]));

  const response = await get(url, authToken);

  if (response.status === 200) {
    return { error: false, result: response.parsedBody };
  }
  return { error: true };
};

const matchGroups = async (
  l1Id,
  l2Id,
  l3Id,
  groups,
  lockIn = false,
  overrideGenderCheck = true,
  authToken
) => {
  const url = `${URL}/roommate/${l1Id}/subnetwork/${l2Id}/unit_type/${l3Id}/match`;

  const response = await post(url, authToken, new Map(), {
    groups,
    lockIn,
    overrideGenderCheck,
  });

  if (response.status === 200) {
    return { error: false };
  }
  return { error: response.parsedBody };
};

const requestAdminAccess = async (
  name,
  email,
  phoneNumber,
  openId,
  organization
) => {
  const url = `${URL}/access/request`;

  const response = await post(url, null, new Map(), {
    name,
    email,
    phoneNumber,
    openId,
    organization,
  });

  return response.status === 200;
};

const getAdminAccessRequests = async (authToken) => {
  const url = `${URL}/access/request`;

  const response = await get(url, authToken);

  const success = response.status === 200;

  return { success, response: response.parsedBody };
};

const acceptAdminAccessRequests = async (requestId, authToken) => {
  const url = `${URL}/access/request/accept?requestId=${requestId}`;

  const response = await post(url, authToken);

  return response.status === 200;
};

// const getAdminUsers = async (
//   networkFilter,
//   page,
//   authToken,
//   data = {},
//   jsonRequest = true
// ) => {
//   let url = `${URL}/access/search`;
//
//   url = `${url}?page=${page}`;
//
//   if (networkFilter) {
//     url = `${url}&networkFilter=${networkFilter}`;
//   }
//
//   data.headers = prepareRequestHeaders(data, jsonRequest, url, authToken);
//
//   const response = await fetch(url, data);
//
//   const status = await response.status;
//
//   const success = status === 200;
//
//   const responseText = await response.text();
//   const responseBody = JSON.parse(responseText);
//
//   return {
//     success,
//     response: responseBody.content,
//     totalElements: responseBody.totalElements,
//     size: responseBody.size,
//     page: responseBody.number,
//   };
// };

const updateAdminUser = async (adminId, changes, authToken) => {
  const url = `${URL}/user/${adminId}`;

  const updateBody = {};

  if (changes.name) {
    updateBody.name = changes.name;
  }
  if (changes.phone) {
    updateBody.phone = changes.phone;
  }
  if (changes.active != null) {
    updateBody.enabled = changes.active;
  }

  if (changes.networks.add.length > 0) {
    updateBody.networksToAdd = changes.networks.add;
  }
  if (changes.networks.remove.length > 0) {
    updateBody.networksToRemove = changes.networks.remove;
  }

  const response = await post(url, authToken, new Map(), updateBody);

  return { success: response.status === 200 };
};

const searchForNetworkByName = async (name, ids, authToken) => {
  let url = `${URL}/networks/search`;

  if (name) {
    url = `${url}?filter=${name}`;
  }

  if (ids && ids.length > 0) {
    const separator = name ? "&" : "?";
    url = `${url + separator}idsToInclude=${ids.join(",")}`;
  }

  const response = await get(url, authToken);

  return { success: response.status === 200, networks: response.parsedBody };
};

const getImportLogs = async (l1Id, authToken) => {
  const url = `${URL}/networks/${l1Id}/import`;

  const response = await get(url, authToken);

  return { success: response.status === 200, logs: response.parsedBody.logs };
};

const sendPush = async (userId, type, authToken) => {
  let url = `${URL}/device/test?type=${type}`;

  if (userId) {
    url = `${url}&userId=${userId}`;
  }

  const response = await post(url, authToken);

  return { success: response.status === 200 };
};

const setMathingRules = async (l1Id, body, authToken) => {
  const url = `${URL_v1}/matching_group/${l1Id}/matching_rules`;

  try {
    const response = await post(url, authToken, new Map(), body);

    const success = response.status === 200;

    return { success, body: response.parsedBody };
  } catch (error) {
    return { success: false };
  }
};

const setPersonalPronouns = async (l1Id, l2Id, body, authToken) => {
  const url = `${URL}/networks/${l1Id}/matching_round/${l2Id}/personal_pronouns`;

  try {
    const response = await post(url, authToken, new Map(), body);
    const success = response.status === 200;

    return { success };
  } catch (error) {
    return { success: false };
  }
};

const setGender = async (l1Id, body, authToken) => {
  const url = `${URL_v1}/matching_group/${l1Id}/matching_rules/gender`;

  try {
    const response = await post(url, authToken, new Map(), body);
    const success = response.status === 200;

    return { success };
  } catch (error) {
    return { success: false };
  }
};

const copyGender = async (l1Id, body, authToken) => {
  const url = `${URL_v1}/matching_group/${l1Id}/matching_rules/gender/copy`;

  try {
    const response = await post(url, authToken, new Map(), body);
    const success = response.status === 200;

    return { success };
  } catch (error) {
    return { success: false };
  }
};

const deleteGender = async (l1Id, genderId, authToken) => {
  const url = `${URL_v1}/matching_group/${l1Id}/matching_rules/gender/${genderId}`;

  const response = await deleteRequest(url, authToken);

  return response.status === 200;
};

const setGenderGroup = async (l1Id, body, authToken) => {
  const url = `${URL_v1}/matching_group/${l1Id}/matching_rules/gender_group`;

  try {
    const response = await post(url, authToken, new Map(), body);
    const success = response.status === 200;

    return { success };
  } catch (error) {
    return { success: false };
  }
};

const deleteGenderGroup = async (l1Id, genderGroupId, authToken) => {
  const url = `${URL_v1}/matching_group/${l1Id}/matching_rules/gender_group/${genderGroupId}`;

  const response = await deleteRequest(url, authToken);

  return response.status === 200;
};

const getCommunityInfo = async (l1Id, authToken) => {
  const url = `${URL}/networks/${l1Id}/description`;

  try {
    const response = await get(url, authToken);

    if (response.status === 200) {
      return { error: false, result: response.parsedBody };
    }

    return { error: true };
  } catch (error) {
    return { error: true };
  }
};

const getProfanityList = async (l1Id, authToken) => {
  const url = `${URL_v1}/matching_group/${l1Id}/profanity_filter`;

  try {
    const response = await get(url, authToken);

    if (response.status === 200) {
      return { error: false, result: response.parsedBody };
    }

    return { error: true };
  } catch (error) {
    return { error: true };
  }
};

const postProfanityFilter = async (l1Id, body, headers, authToken) => {
  const url = `${URL_v1}/matching_group/${l1Id}/profanity_filter`;

  const response = await post(url, authToken, new Map(), body, headers);

  if (response.status === 200) {
    return { error: false };
  }
  return { error: true };
};

const setCommunityInfo = async (l1Id, description, authToken) => {
  const url = `${URL}/networks/${l1Id}/description`;

  try {
    const response = await post(url, authToken, new Map(), { description });

    const success = response.status === 200;

    if (success) {
      return { error: false };
    }

    return { error: true };
  } catch (error) {
    return { error: true };
  }
};

const loadTags = async (authToken) => {
  const url = `${URL_v1}/questions_tag`;

  const entrataUserHttpResponse = await get(url, authToken);

  return entrataUserHttpResponse.parsedBody;
};

const removeTag = async (tagId, authToken) => {
  const url = `${URL_v1}/questions_tag/${tagId}`;

  const response = await deleteRequest(url, authToken);

  return response.status === 200;
};

const updateTag = async (tagId, name, authToken) => {
  const url = `${URL_v1}/questions_tag/${tagId}`;

  const response = await post(url, authToken, new Map(), { id: tagId, name });

  return response;
};

const addTag = async (name, authToken) => {
  const url = `${URL_v1}/questions_tag`;

  const response = await post(url, authToken, new Map(), { name });

  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loadTags,
  updateTag,
  addTag,
  removeTag,
  setGender,
  setPersonalPronouns,
  deleteGenderGroup,
  deleteGender,
  copyGender,
  setGenderGroup,
  postProfanityFilter,
  getProfanityList,
  setMathingRules,
  getCurrrentMatchesOfMatchesGroup,
  // loginGoogle,
  // loginEntrata,
  getHome,
  getRoommateMatchReport,
  getUserReport,
  getRoommateMatchReportCSV,
  getUserReportCSV,
  getUserSearchByName,
  getUserSearchByPin,
  deleteUserMembership,
  deleteUser,
  clearNetwork,
  requestDatesChange,
  // requestPasscodeChange,
  getHousingOptions,
  getMajorsOptions,
  requestActivationChangeHousingMajorEntry,
  requestNewOrEditExistingHousingMajorEntry,
  requestReplaceHousingMajorEntries,
  requestCopyQuestions,
  requestCopyHousingMajorEntries,
  getQuestionsForNetwork,
  // updateStandardNetworkQuestions,
  updateNetworkQuestionData,
  // createNetworkQuestion,
  // deleteNetworkQuestion,
  loadReportSubscriptions,
  loadRooms,
  matchGroups,
  requestAdminAccess,
  getAdminAccessRequests,
  acceptAdminAccessRequests,
  // getAdminUsers,
  updateAdminUser,
  searchForNetworkByName,
  getImportLogs,
  sendPush,
  // refreshToken,
  updateNetworkQuestionOrder,
  getCommunityInfo,
  setCommunityInfo,
};
